import { jsxs, jsx } from 'react/jsx-runtime';

const TransparentIcon = ({
  size,
  color = "currentColor"
}) => {
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    style: {
      width: `${size.toString()}px`,
      height: `${size.toString()}px`
    },
    children: [/*#__PURE__*/jsx("path", {
      fill: "none",
      d: "M-1-1h582v402H-1z"
    }), /*#__PURE__*/jsx("defs", {
      children: /*#__PURE__*/jsx("path", {
        id: "a",
        d: "M0 0v32h32V0H0zm4.9 26.2l-2.8-2.8L22.8 2.6l2.8 2.8L4.9 26.2z"
      })
    }), /*#__PURE__*/jsx("clipPath", {
      id: "b",
      children: /*#__PURE__*/jsx("use", {
        xlinkHref: "#a",
        overflow: "visible"
      })
    }), /*#__PURE__*/jsx("g", {
      clipPath: "url(#b)",
      children: /*#__PURE__*/jsx("path", {
        d: "M16 32C9.3 32 4 26.6 4 20 4 12 14 0 16 0s12 12 12 20c0 6.6-5.4 12-12 12zm7-12c-.6 0-1 .4-1 1 0 2.8-2.2 5-5 5-.6 0-1 .4-1 1s.4 1 1 1c3.9 0 7-3.1 7-7 0-.5-.5-1-1-1z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: color
      })
    }), /*#__PURE__*/jsx("path", {
      fill: "none",
      stroke: color,
      strokeWidth: "4",
      d: "M30.2 3.7L3.4 30.5"
    })]
  });
};

export { TransparentIcon };
//# sourceMappingURL=TransparentIcon.js.map
